import { dashboardMapping } from './dashboardMapping';
import { menumapping } from './menuMapping';
type PermissionMapping = {
  [key: string]: {
    controller: string;
    function: string;
  };
};

// Merge both mappings
const PERMISSION_MAPPINGS: PermissionMapping = {
  ...menumapping,
  ...dashboardMapping
};

export function getPermissionMapping(key: string) {
  return PERMISSION_MAPPINGS[key] || null;
}
